import { BufferGeometry, Intersection, Points, Raycaster, Vector3 } from 'three';

import { CesiumPointsMaterial } from './material/cesium-point-material';

export class CesiumPoints extends Points {
  constructor(
    geometry: BufferGeometry,
    readonly geometricError: number,
  ) {
    super(geometry, CesiumPointsMaterial.instance.material);
  }

  getPointClassification(index: number) {
    return this.geometry.getAttribute('classification').array[index];
  }

  raycasterIntersection(rayCaster: Raycaster): Intersection[] {
    if (!this.intersectsWorldBoundingSphere(rayCaster)) {
      return [];
    }

    const oldThreshold = rayCaster.params.Points.threshold;
    rayCaster.params.Points.threshold = this.geometricError;

    const intersections = rayCaster.intersectObject(this, false);
    rayCaster.params.Points.threshold = oldThreshold;

    if (!CesiumPointsMaterial.instance.displayClasses) {
      return intersections;
    } else {
      return intersections.filter((intersection) => {
        const pointClass = this.getPointClassification(intersection.index!);
        return CesiumPointsMaterial.instance.isClassificationVisible(pointClass);
      });
    }
  }

  setPointSizeScale(scale: number) {
    CesiumPointsMaterial.instance.pointScale = scale;
  }

  /**
   *  Returns true if intersecting with world boundary sphere of the chunk.
   *
   *  @param rayCaster - The ray caster to check intersection against.
   */
  private intersectsWorldBoundingSphere(rayCaster: Raycaster) {
    const chunkWorldPosition = this.getWorldPosition(new Vector3());

    // Corrects the ray against the chunks world position.
    rayCaster.ray.origin.sub(chunkWorldPosition);
    const intersectsBoundaryVolume = rayCaster.ray.intersectsSphere(this.geometry.boundingSphere!);
    rayCaster.ray.origin.add(chunkWorldPosition);

    return intersectsBoundaryVolume;
  }
}
